/* The mockup's `.topbar` and `.crumbs`. */
.topbar {
  display: flex;
  flex: none;
  align-items: center;
  gap: var(--space-2);
  block-size: var(--layout-topbar);
  min-inline-size: 0;
  padding: 0 var(--space-3);
  border-bottom: 1px solid var(--border);
  background: var(--surface-raised);
}

.crumbs {
  display: flex;
  align-items: center;
  gap: 6px;
  min-inline-size: 0;
  font-size: var(--font-size-13);
  white-space: nowrap;
}

.parent {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--text-subtle);
}

.separator::before {
  content: "/";
  color: var(--border-strong);
}

.current {
  overflow: hidden;
  color: var(--text);
  font-weight: var(--font-weight-medium);
  text-overflow: ellipsis;
}

.spacer {
  flex: 1;
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.actions:empty {
  display: none;
}

/* A page's own title area (the Lienzo editor's name and chips), after the breadcrumb. */
.title {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-inline-size: 0;
}

.title:empty {
  display: none;
}
